import React, { useEffect, useRef, useState } from "react";
import { SketchPicker } from "react-color";
import { Col, Form, Button } from "react-bootstrap";

const ColorPickerPopover = ({
  label,
  value,
  onChange,
  defaultColor = "#D5B086",
  presetColors = [],
}) => {
  const [showPicker, setShowPicker] = useState(false);
  const currentColor = value || defaultColor;

  const pickerRef = useRef(null);

  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (pickerRef?.current && !pickerRef?.current.contains(event.target)) {
        setShowPicker(false);
      }
    };

    if (showPicker) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showPicker]);

  return (
    <div style={{ position: "relative" }} ref={pickerRef}>
      {label && <Form.Label>{label}</Form.Label>} {/* Color preview button */}
      <br />
      <Button
        style={{
          backgroundColor: currentColor,
          border: "4px solid #ffffff",
          width: "40px",
          height: "40px",
          padding: 0,
          borderRadius: 6,
        }}
        onClick={() => setShowPicker(!showPicker)}
      >
        &nbsp;
      </Button>
      {/* Popover picker */}
      {showPicker && (
        <div
          style={{
            position: "absolute",
            zIndex: 1000,
            top: "50px",
          }}
        >
          <SketchPicker
            color={currentColor}
            onChange={(color) => onChange(color.hex)}
            presetColors={presetColors.length > 0 ? presetColors : undefined}
            styles={{
              default: {
                alpha: { display: "none" }, // Hide opacity slider
                // Hide alpha input box
                controls: {
                  display: "flex",
                },
                color: {
                  alpha: "0 !important", // no alpha
                },
              },
            }}
          />
          <Button
            size="sm"
            variant="secondary"
            onClick={() => setShowPicker(false)}
            style={{ marginTop: "5px", width: "100%" }}
          >
            Close
          </Button>
        </div>
      )}
    </div>
  );
};

export default ColorPickerPopover;
